import { colors } from '../tokens/colors';

export const lightTheme = {
  '--bg-color': '#ffffff',
  '--bg-color-secondary': '#f5f5f5',
  '--text-primary': '#000000',
  '--text-secondary': '#666666',
  '--primary-color': '#007AFF',
  '--hover-color': 'rgba(0, 122, 255, 0.1)',
  '--border-color': '#e0e0e0',
  '--divider-color': 'rgba(0, 0, 0, 0.1)',
  colors: {
    ...colors
  }
}; 